import { useTransactionData } from "./transactions/useTransactionData";
import { useSummaryCalculations } from "./transactions/useSummaryCalculations";

export interface PaymentSummary {
  method: string;
  amount: number;
  counted?: number;
  transactions?: Array<{
    date: string;
    amount: number;
    type: string;
    notes?: string;
  }>;
}

export const usePaymentSummaries = (period: string) => {
  const { data: transactions } = useTransactionData(period);
  const { calculateSummaries } = useSummaryCalculations();

  return {
    summaries: calculateSummaries(transactions),
    isLoading: !transactions,
  };
};